var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row w-100"},_vm._l(([1, 2, 3, 4, 5, 6, 7, 8, 9]),function(i){return _c('div',{key:i,staticClass:"col-md-4",staticStyle:{"padding-bottom":"30px"}},[_c('div',{staticClass:"content-card skeleton-block skeleton-effect-fade"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }